import { render } from "./ParamFarmViewV2.vue?vue&type=template&id=6d393748&scoped=true"
import script from "./ParamFarmViewV2.vue?vue&type=script&lang=js"
export * from "./ParamFarmViewV2.vue?vue&type=script&lang=js"

import "./ParamFarmViewV2.vue?vue&type=style&index=0&id=6d393748&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d393748"]])

export default __exports__